export const config = {
    contentTitle: '分支机构',
    contentDesc: '敬在在多地设有分级机构或交付运维团队，用心做好本地化服务，关注实施落地，保障运维体验。',
    contentImg: require('@/assets/images/branch/img_company_address.png'),
    contentMore: [
        { title: '专业团队', info: '国内最早的HRP专业团队，专注医院智慧管理' },
        { title: '19+服务经验', info: '19+年医院运营管理信息化服务经验，众多大型三甲、医疗集团、医共体成功案例' },
        { title: '咨询基因', info: 'iT规划与咨询能力，医院业务流程梳理+管理方案设计' },
        { title: '顶尖高校', info: '团队核心成员来自C9/985院校' },
        { title: '一流实施', info: '全球顶级管理软件SAP、ORACLE实施经验' },
        { title: '先进方案', info: '支持医院达成《智慧管理分级评估标准的最高级别》' },
        { title: '技术革新', info: '坚持IT前治技术革新，融合管理创新实践及云原生微服务架构、云计算、数据等新兴技术应用' },
        { title: '运维保障', info: '365*7*24小时运维服务保障，专业团队驻场服务，巡检升级服务' }
    ]
}
